import Layout from '@/src/layout/EditorPageLayout/EditorPageLayout';
import React, { useMemo } from 'react';
import { Form } from 'src/components/Antd';
import {
  getIDOfTimezone,
  getSalesChannels,
} from 'src/constrains/GlobalProvider/slice';
import { EProductType } from 'src/pages/StoreVoucher/Detail/Components/ProductsApplyToRadioAndTable';
import {
  archiveStoreVoucher,
  draftStoreVoucher,
  getStoreVoucher,
  postStoreVoucher,
  publishStoreVoucher,
} from 'src/request/voucher';
import Attributes from './Attribute';
import BasicInfo from './BasicInformation';
import FixedReduction from './FixedReduction';
import FreeItem from './FreeItems';
import Left from './Header/TopLeft';
import Right from './Header/TopRight';
import PercentageOff from './PercentageOff';
import ShippingDiscount from './ShoppingDIscount';
import Summary from './Summary';
import UsageCondition, { EApplyTo } from './UsageCondition';
import UsageLimitation from './UsageLimitation';
import Record from './UsageRecord';
import VoucherQuantity from './VoucherQuantity';
import VoucherSendTo from './VoucherSendTo';
import Method, { EMethod } from './VoucherType';

import { ECondition } from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/CustomerEligibleCondition';
import { EShipping, EnumStatus } from 'src/types/common/discount';

import { get } from 'lodash';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { useI18n } from 'src/hooks/useRouterChange';
import { NEW } from 'src/tools/constant';
import { isUserValid, storeResourceNameGenerator } from 'src/tools/getUserInfo';
import { getParameter, onFinishFailed, timeoutScroll } from 'src/tools/helper';
import { msg } from 'src/tools/message';
import { i18nGet } from 'src/tools/tools';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';
import { modal } from 'src/utils/Modal';
import { switchUuidHooks } from './hooks';
import {
  convertDataFromServer,
  convertDataFromState,
  handleOnCheckTime,
} from './tools';

const nameDuplicate = 120345;
const formName = 'storeVoucherForm';
const freeItemName = ['voucherMethod', 'salesChannelGifts'];
const customerConditionName = 'customerCondition';
const draftValidating = [
  'voucherNo',
  'customerDatabase',
  'currency',
  'salesChannels',
];
const Voucher = (props) => {
  const idOfTimeZone = useSelector(getIDOfTimezone()) || '';
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const canEdit = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Voucher,
        subCategory: EnumSubCategory.StoreVoucher,
        operation: EnumOperation.add_edit_voucher,
      }),
    ],
  });
  const canChangeStatus = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Voucher,
        subCategory: EnumSubCategory.StoreVoucher,
        operation: EnumOperation.archive_publish_unpublish,
      }),
    ],
  });

  //const m: any = useLocation();
  // const { defaultName } = qs.parse(m.search);
  const [form] = Form.useForm();
  const history = useHistory();
  const { discountUuid }: any = useParams();
  const disabled = Boolean(getParameter('disabled')) || !canEdit;
  const isNew = discountUuid === NEW;
  const defaultState = {
    status: EnumStatus.Draft,
    voucherType: EMethod.Percentage,
    applyTo: { conditionType: EProductType.All },
    //  salesChannelUuid: uuid,
    uuid: null,
    voucherMethod: {
      shippingDiscountType: EShipping.Free,
    },
    customerCondition: { conditionType: ECondition.Registered },
    usageCondition: {
      basedOn: EApplyTo.None,
    },
    voucherQuantity: { limited: false, totalQuantity: null },
    used: 0,
    delivered: 0,
    total: 0,
    // name: defaultName || '',
  };
  const [data, setData] = React.useState(defaultState);
  //const [timezone,setTimezone]=React.useState("")
  const { uuid: dUuid, status, used, delivered, total } = data;
  // const disabled = false;
  const remaining = (total || 0) - (used || 0) - (delivered || 0);
  const isDraftArchive =
    status === EnumStatus.Draft || status === EnumStatus.Archived;
  const isActive =
    status === EnumStatus.Issued ||
    status === EnumStatus.Scheduled ||
    status === EnumStatus.Expired ||
    status === EnumStatus.Active;
  console.log('isActive', isActive);
  switchUuidHooks({ uuid: dUuid });
  const [loaded, setLoaded] = React.useState(false);
  const [dbs, setDBs] = React.useState([]);
  const [currentDb, setCurrentDb] = React.useState(null);
  const [time, setTime] = React.useState({
    beginDate: null,
    beginTime: null,
    endDate: null,
    endTime: null,
  });

  const [timeHasError, setTimeHasError] = React.useState(false);
  const [hasModified, setHasModified] = React.useState(false);
  const globalSalesChannels = useSelector(getSalesChannels());
  //const [featureImage, setFeatureImage] = React.useState(null);

  const salesChannels = useMemo(() => {
    return globalSalesChannels.reduce((pre, now) => {
      const { uuid, name } = now;
      return { ...pre, [uuid]: name };
    }, {});
  }, [globalSalesChannels]);

  const handleOnResponse = (response: any) => {
    const { data, status, errorCode, errMsg, code } = response;
    if (data && status == 200) {
      return {
        valid: true,
        data: data.payload,
      };
    }
    if (errorCode == nameDuplicate && code == 400) {
      timeoutScroll(`${formName}_voucherNo`);
      form.setFields([{ name: 'voucherNo', errors: [errMsg] }]);
      return {
        valid: false,
      };
    }
    modal.error({
      title: getI18n('general.requestError'),
      content: errMsg || getI18n('general.systemError,PleaseContactAdmin'),
      onCancel: () => {
        console.error(
          errMsg || getI18n('general.systemError,PleaseContactAdmin'),
        );
      },
      onCancelText: getI18n('general.confirm'),
    });

    return {
      valid: false,
    };
  };

  const handleOnAssData = (res) => {
    const _data = convertDataFromServer(res);
    setData(_data);
    const {
      customerDatabase,
      currency,
      salesChannels,
      voucherNo,
      description,
      featureImage,
      voucherQuantity,
      voucherType,
      voucherMethod,
      usageLimitation,
      customerCondition,
      applyTo,
      usageCondition,
      attributes,
      beginDate,
      beginTime,
      endDate,
      endTime,
    } = _data;
    setTime({ beginDate, beginTime, endDate, endTime });
    setCurrentDb(customerDatabase);
    form.setFieldsValue({
      customerDatabase,
      currency,
      salesChannels,
      voucherNo,
      description,
      featureImage,
      voucherQuantity,
      voucherType: voucherType || defaultState.voucherType,
      voucherMethod: voucherMethod || defaultState.voucherMethod,
      usageLimitation,
      customerCondition: customerCondition || defaultState.customerCondition,
      applyTo: applyTo || defaultState.applyTo,
      usageCondition: usageCondition || defaultState.usageCondition,
      attributes,
    });
  };

  const getData = () => {
    if (isNew) {
      form.setFieldsValue(defaultState);
      getStoreVoucher({}).then((res) => {
        const dbs = get(res, 'dbChannelCurrencies');
        setDBs(dbs);
        setLoaded(true);
      });
    } else {
      getStoreVoucher({
        params: {
          voucherUuid: discountUuid,
        },
      }).then((res) => {
        const dbs = get(res, 'dbChannelCurrencies');
        const voucher = get(res, 'voucher');
        handleOnAssData(voucher || {});
        setDBs(dbs);
        setLoaded(true);
      });
    }

    // getDirectDiscount(discountUuid, salesChannelMultiLanguageQueryParams)
    //   .then((res) => {
    //     setData(res);
    //     const { status } = res;
    //     handleOnAssData(res);

    //     setLoaded(true);
    //     return status;
    //   })
    //   .then((status) => {
    //     if (status === EnumStatus.Draft || status === EnumStatus.Archived) {
    //       //  form.validateFields();
    //     }
    //   });
  };

  React.useEffect(() => {
    getData();
  }, []);
  //
  const handleOnGetData = () => {
    const value = form.getFieldsValue();

    const _value = convertDataFromState(value) || {};
    const submitData = {
      ...data,
      ..._value,
      ...time,
    };

    return submitData;
  };

  const handleOnError = (error) => {
    onFinishFailed(formName, error);
    return false;
  };

  const currency = (
    <Form.Item
      shouldUpdate={(p, c) => {
        const pV = get(p, 'currency');
        const cV = get(c, 'currency');
        return pV !== cV;
      }}>
      {({ getFieldValue }) => {
        const c = getFieldValue('currency');
        return c || '';
      }}
    </Form.Item>
  );

  const handleOnSubmitDraft = () => {
    return form
      .validateFields(draftValidating) //
      .then((res) => {
        const submitData = handleOnGetData();

        return postStoreVoucher(submitData).then((res) => {
          const { valid, data } = handleOnResponse(res);
          if (valid) {
            setData(data);
            msg.success(getI18n('general.successfullyupdated'));
            setHasModified(false);
            return true;
          }
          return false;
        });
      })
      .catch(handleOnError);
  };

  const handleOnSubmitPublish = () => {
    const { valid: isTimeValid } = handleOnCheckTime(time || {}, idOfTimeZone);
    if (isTimeValid) {
      return form
        .validateFields()
        .then((res) => {
          const submitData = handleOnGetData();

          return postStoreVoucher(submitData).then((res) => {
            const { valid, data } = handleOnResponse(res);
            if (valid) {
              setData(data);
              msg.success(getI18n('general.successfullyupdated'));
              setHasModified(false);
              return true;
            }
            return false;
          });
        })
        .catch(handleOnError);
    } else {
      setTimeHasError(true);
      timeoutScroll('StoreVoucherStartAndEndTime');
    }
  };

  const handleOnSubmit = () => {
    if (isDraftArchive) {
      return handleOnSubmitDraft();
    }
    if (isActive) {
      return handleOnSubmitPublish();
    }
  };
  const handleOnDuplicate = () => {
    const _duplicate = () => {
      const submitData = handleOnGetData();
      submitData.voucherNo = '';
      submitData.status = EnumStatus.Draft;
      submitData.uuid = null;
      handleOnAssData(submitData);
      history.push({
        pathname: `/storeVoucherEdit/${NEW}`,
        state: {
          skipNotice: true,
        },
      });
      msg.destroy();
      msg.success(getI18n('general.duplicated'));
      timeoutScroll('tcContentTop');
    };
    //duplicate都是draft
    form.validateFields([]).then(() => {
      //好像不用validate
      if (hasModified) {
        const promise = handleOnSubmit();
        if (promise) {
          promise.then((bol) => {
            if (bol) {
              _duplicate();
            }
          });
        }
      } else {
        _duplicate();
      }
    });
  };
  const handleOnToDraft = () => {
    form
      .validateFields(draftValidating)
      .then(() => {
        if (hasModified) {
          modal.info({
            title: getI18n('general.saveChanges'),
            content: getI18n('general.saveDiscount'),
            //onCancel,
            onOkText: getI18n('general.saveChanges'),
            onOk: () => handleOnSubmit(),
            // onCancelText,
          });
        } else {
          const submitData = handleOnGetData();
          const { uuid } = submitData;
          draftStoreVoucher([uuid]).then((res) => {
            msg.success(getI18n('general.successfullyupdated'));
            const status = EnumStatus.Draft;
            setData({ ...data, status });
            // handleOnAssData(res);
          });
        }
      })
      .catch(handleOnError);
  };
  const handleOnToArchive = () => {
    modal.info({
      title: getI18n('voucher.storeVoucherDetail.archiveDiscount'),
      content: getI18n('general.archiveTip'),
      //onCancel,
      onOkText: 'Archive',
      onOk: () => {
        return form
          .validateFields(draftValidating)
          .then(() => {
            if (hasModified) {
              modal.info({
                title: getI18n('general.saveChanges'),
                content: getI18n('general.saveDiscount'),
                onCancel: () => {
                  return;
                },
                onOkText: getI18n('general.saveChanges'),
                onOk: () => handleOnSubmit(),
                // onCancelText,
              });
            } else {
              const submitData = handleOnGetData();
              const { uuid } = submitData;
              archiveStoreVoucher([uuid]).then((res) => {
                msg.success(getI18n('general.successfullyupdated'));
                const status = EnumStatus.Archived;
                setData({ ...data, status });
              });
            }
          })
          .catch(handleOnError);
      },
      // onCancelText,
    });
  };
  const handleOnToPublish = () => {
    const { valid: isTimeValid, message } = handleOnCheckTime(
      time || {},
      idOfTimeZone,
    );
    if (isTimeValid) {
      return form
        .validateFields()
        .then(() => {
          if (hasModified) {
            modal.info({
              title: getI18n('general.saveChanges'),
              content: getI18n('general.publishTip'),
              //onCancel,
              onOkText: getI18n('general.saveChanges'),
              onOk: () => handleOnSubmitPublish(),
              // onCancelText,
            });
          } else {
            const submitData = handleOnGetData();
            const { uuid } = submitData;

            publishStoreVoucher([uuid]).then((res) => {
              const { valid, data: rData } = handleOnResponse(res);
              if (valid) {
                const status = (rData || [])[0] || EnumStatus.Active; //可能要改
                msg.success(getI18n('general.successfullyupdated'));
                //const status = EnumStatus.Active;
                setData({ ...data, status });
                if (data.uuid) {
                  history.replace(
                    `/storeVoucherEdit/${data.uuid}?disabled=true`,
                  );
                }
              } else {
              }
            });
          }
        })
        .catch((e) => {
          modal.info({
            title: getI18n('general.unabletoPublish'),
            content: getI18n('general.fixAllErr'),
            //onCancel,
            onOkText: getI18n('general.antd.Uploader.ok'),
            onOk: () => onFinishFailed(formName, e),
            // onCancelText,
          });
        });
    } else {
      modal.info({
        title: getI18n('general.unabletoPublish'),
        content: message || 'Please correct start and end time',
        //onCancel,
        onOkText: getI18n('general.antd.Uploader.ok'),
        onOk: () => {
          setTimeHasError(true);
          timeoutScroll('StoreVoucherStartAndEndTime');
        },
        // onCancelText,
      });
    }
  };

  return (
    <React.Fragment>
      <Form
        name={formName}
        form={form}
        onValuesChange={(changedValues, allValues) => {
          const { customerDatabase } = allValues;
          setCurrentDb(customerDatabase);
          setHasModified(true);
        }}>
        {loaded && (
          <Form.Item
            shouldUpdate={(p, c) => {
              const pV = get(p, 'voucherType');
              const cV = get(c, 'voucherType');
              return pV !== cV;
            }}>
            {({ getFieldValue }) => {
              const type = getFieldValue('voucherType');
              const _method = () => {
                if (type === EMethod.Percentage) {
                  return [
                    {
                      child: (
                        <PercentageOff
                          currency={currency}
                          disabled={disabled}
                        />
                      ),
                    },
                  ];
                }
                if (type === EMethod.Reduction) {
                  return [
                    {
                      child: (
                        <FixedReduction
                          currency={currency}
                          disabled={disabled}
                        />
                      ),
                    },
                  ];
                }
                if (type === EMethod.Shipping) {
                  return [
                    {
                      child: (
                        <ShippingDiscount
                          currency={currency}
                          disabled={disabled}
                        />
                      ),
                    },
                  ];
                }
                if (type === EMethod.Gift) {
                  return [
                    {
                      child: (
                        <FreeItem
                          allSalesChannels={salesChannels}
                          salesChannelName={'salesChannels'}
                          freeItemName={freeItemName}
                          disabled={disabled}
                        />
                      ),
                    },
                  ];
                }
                return [];
              };

              const ele = [
                {
                  child: (
                    <Summary
                      noInfo={isNew && !hasModified}
                      status={status}
                      activeTime={time}
                      currentDb={currentDb}
                      dbs={dbs}
                      total={total}
                      used={used}
                      delivered={delivered}
                      remaining={remaining}
                      disabled={disabled}
                      isDraftArchive={isDraftArchive}
                    />
                  ),
                },
                {
                  child: (
                    <BasicInfo
                      time={time}
                      // featureImage={featureImage}
                      timeError={timeHasError}
                      onTimeChang={(time) => {
                        setTime(time);
                        setTimeHasError(false);
                        setHasModified(true);
                      }}
                      // onImageChange={setFeatureImage}
                      dbs={dbs}
                      form={form}
                      freeItemName={freeItemName}
                      customerConditionName={customerConditionName}
                      disabled={disabled}
                    />
                  ),
                },
                {
                  child: <VoucherQuantity disabled={disabled} />,
                },
                {
                  child: <Method disabled={disabled} />,
                },
                ..._method(),
                {
                  child: <UsageLimitation form={form} disabled={disabled} />,
                },
                {
                  child: (
                    <VoucherSendTo
                      form={form}
                      currentDb={currentDb}
                      disabled={disabled}
                      uuid={dUuid}
                    />
                  ),
                },

                {
                  child: (
                    <UsageCondition
                      form={form}
                      currency={currency}
                      disabled={disabled}
                    />
                  ),
                },
                ...(isNew || isDraftArchive
                  ? []
                  : [
                      {
                        child: (
                          <Record
                            data={[
                              {
                                title: getI18n(
                                  'voucher.storeVoucherDetail.totalVouchers',
                                ),
                                amount: total,
                              },
                              {
                                title: getI18n(
                                  'voucher.storeVoucherDetail.vouchersDelivered',
                                ),
                                amount: delivered,
                              },
                              {
                                title: getI18n(
                                  'voucher.storeVoucherDetail.vouchersUsed',
                                ),
                                amount: used,
                              },
                              {
                                title: getI18n(
                                  'voucher.storeVoucherDetail.remainingVouchers',
                                ),
                                amount: remaining,
                              },
                              //    { title: 'Total Vouchers', amount: 2 },
                            ]}
                          />
                        ),
                      },
                    ]),
                {
                  child: <Attributes form={form} disabled={disabled} />,
                },
              ];
              return (
                <Layout
                  topLeft={<Left />}
                  topRight={
                    <Right
                      status={status}
                      isNew={isNew}
                      canChangeStatus={canChangeStatus}
                      onDraft={handleOnToDraft}
                      onRestore={handleOnToDraft}
                      onPublish={handleOnToPublish}
                      onArchive={handleOnToArchive}
                      onDuplicate={handleOnDuplicate}
                      onSubmit={handleOnSubmit}
                      hasModified={hasModified}
                      disabled={disabled}
                      canEdit={canEdit}
                    />
                  }
                  elements={ele}
                />
              );
            }}
          </Form.Item>
        )}
      </Form>
    </React.Fragment>
  );
};
export default Voucher;
